import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { Button } from '@/components/ui/button';

const SIGNUP_URL = 'https://app.lealitycard.com/es-es/b/salkantay/registro';

const LoyaltyCard = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="fidelizacion"
      data-testid="loyalty-section"
      ref={ref}
      className="py-20 md:py-32 bg-coffee relative overflow-hidden"
    >
      {/* Background Decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-terracotta/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-gold/10 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          {/* Card Image */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="flex justify-center lg:justify-start"
          >
            <a
              href={SIGNUP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="block group"
              data-testid="loyalty-card-link"
            >
              <img
                src="/loyalty/salkantay-puntos-card.png"
                alt="Tarjeta digital de puntos Salkantay"
                className="w-full max-w-md drop-shadow-2xl transition-transform duration-300 group-hover:scale-105"
              />
            </a>
          </motion.div>

          {/* Text */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <span className="text-gold font-medium uppercase tracking-widest text-sm">
              Club Salkantay
            </span>
            <h2
              className="font-heading text-4xl md:text-5xl font-bold text-white mt-4 mb-6"
              data-testid="loyalty-title"
            >
              Empieza a ganar
            </h2>
            <p
              className="text-white/75 text-lg leading-relaxed mb-10"
              data-testid="loyalty-description"
            >
              En Salkantay queremos darte las gracias por elegirnos. Únete a nuestro club y, en
              cada visita, suma puntos que podrás canjear por descuentos, platos especiales y
              sorpresas pensadas para ti. ¡Regístrate gratis y descubre más motivos para volver!
            </p>
            <Button
              asChild
              className="bg-terracotta hover:bg-terracotta-dark text-white rounded-full px-8 py-6 text-lg font-medium transition-all duration-300 hover:scale-105 shadow-lg"
              data-testid="loyalty-signup-btn"
            >
              <a href={SIGNUP_URL} target="_blank" rel="noopener noreferrer">
                Unirme al Club
              </a>
            </Button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default LoyaltyCard;
